import styled, { css } from '@xstyled/styled-components';
import { CrossOut } from '@/UI/utils';

export const ProductDetails = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 4rem 0;

  @media (max-width: desktop) {
    display: flex;
    flex-direction: column;
    margin: 0;
  }
`;

export const ProductInformation = styled.div`
  margin-left: 6rem;

  p,
  h4 {
    font-weight: 400;
  }

  h4 {
    padding-bottom: 1rem;
  }

  p {
    max-width: 400px;
    padding-bottom: 2rem;
  }

  a {
    font-size: 0.875rem;
    text-decoration: underline;
  }

  a.brand_logo {
    position: absolute;
    width: 100px;
    height: 100px;
    top: 20px;
    right: 0;
  }

  @media (max-width: desktop) {
    margin-left: 0;
    padding: 0 1rem;

    a.brand_logo {
      display: none;
    }
  }

  ${({ error }) =>
    error &&
    css`
      h4 {
        color: red;
        text-decoration: underline;
      }
    `}
`;

export const PriceInformation = styled.span`
  display: flex;
  align-items: center;
  padding-bottom: 2rem;
  font-size: large;
  font-weight: 500;
  color: teal-200;

  div {
    font-weight: 500;
    font-size: medium;
  }

  > span {
    margin-left: 2rem;
    font-size: xsmall;
    color: blue-200;

    span {
      position: relative;
      font-size: small;

      &:after {
        ${CrossOut}
      }
    }
  }

  @media (max-width: desktop) {
    flex-direction: column-reverse;
    align-items: flex-start;

    > span {
      margin-left: 0;

      span {
        margin-left: 0.5rem;
      }
    }
  }
`;
